import { EventEmitter, Injectable, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class NotifyService {
    @Output()
    cashSubmitted = new EventEmitter();
    @Output()
    customerSaved = new EventEmitter();
    @Output()
    orderPlaced = new EventEmitter();
    @Output()
    orderReceived = new EventEmitter();
    @Output()
    orderDelivered = new EventEmitter();
    @Output()
    orderCancelled = new EventEmitter();
    @Output()
    orderModified = new EventEmitter();
    @Output()
    updateDashboard = new EventEmitter();

    @Output()
    inventoryUpdated = new EventEmitter();

    constructor(public http: HttpClient) {}

    CashSubmitted(data = null) {
        this.cashSubmitted.emit(data);
    }

    InventoryUpdated(data = null) {
        this.inventoryUpdated.emit(data);
    }

    UpdateDashboard(data = null) {
        this.updateDashboard.emit(data);
    }

    CustomerSaved(data = null) {
        this.customerSaved.emit(data);
    }

    OrderPlaced(data = null) {
        this.orderPlaced.emit(data);
    }

    OrderReceived(data = null) {
        this.orderReceived.emit(data);
    }

    OrderDelivered(data = null) {
        this.orderDelivered.emit(data);
    }

    OrderCancelled(data = null) {
        this.orderCancelled.emit(data);
    }

    OrderModified(data = null) {
        this.orderModified.emit(data);
    }
}



// WEBPACK FOOTER //
// ./src/services/notify.service.ts